import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { CgMenuGridO } from "react-icons/cg";
import { IoClose } from "react-icons/io5";
import { FaLanguage } from "react-icons/fa";
import ResponsiveMenu from "./ResponsiveMenu";
import logo from "../assets/finance7.png";
import Translator from "./Essentials/Translator";

const navItems = [
  { path: "/", label: "Home" },
  { path: "/login", label: "Dashboard" },
  { path: "/plans", label: "Plans" },
  { path: "/solutions", label: "Our Solution" },
  { path: "/contact", label: "Contact Us" },
];

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [showTranslator, setShowTranslator] = useState(false);

  const toggleMenu = () => setShowMenu(!showMenu);
  const toggleTranslator = () => setShowTranslator(!showTranslator);

  const handleHomeClick = () => {
    window.scrollTo(0, 0);
    window.location.href = "/";
  };

  return (
    <>
      <header className="fixed top-0 left-0 w-full z-[1050]">
        {/* Notification Banner */}
        <div className="w-full bg-gray-100 text-[#000] text-center py-1 text-sm font-medium">
          <span className="hidden lg:inline">Not English? Click 'Change Language'</span>
          <span className="lg:hidden text-xs">Not English? Click below</span>
        </div>

        <nav className="bg-[#000300] shadow-md w-full relative z-[1050]">
          {/* Main Navbar Container - Increased height for medium screens */}
          <div className="container mx-auto flex items-center justify-between py-3 md:py-4 px-1 sm:px-6 lg:px-8">
            {/* Mobile Menu Button - Left Side */}
            <div className="md:hidden flex items-center justify-start mx-4">
              {showMenu ? (
                <IoClose
                  onClick={toggleMenu}
                  className="text-[#fff] cursor-pointer transition-transform hover:scale-110"
                  size={26}
                />
              ) : (
                <CgMenuGridO
                  onClick={toggleMenu}
                  className="text-[#fff] cursor-pointer transition-transform hover:scale-110"
                  size={24}
                />
              )}
            </div>

            {/* Logo Section - Centered on tablet with increased size */}
            <div className="flex items-center md:absolute ml-8 mx-4 md:left-1/2 md:-translate-x-1/2 lg:static lg:transform-none lg:mr-4">
              <Link to="/" onClick={handleHomeClick}>
                <img 
                  src={logo} 
                  alt="Logo" 
                  className="h-7 sm:h-9 md:h-11 lg:h-12 w-auto" 
                />
              </Link>
            </div>

            {/* Desktop Navigation - Hidden on tablet */}
            <div className="hidden lg:flex items-center justify-center flex-grow">
              <ul className="flex items-center space-x-6 xl:space-x-8">
                {navItems.map(({ path, label }) => (
                  <li key={path}>
                    <NavLink
                      to={path}
                      className={({ isActive }) =>
                        `text-md whitespace-nowrap transition-colors duration-300 ${
                          isActive 
                            ? "text-gray-400 font-semibold" 
                            : "text-white hover:text-gray-400"
                        }`
                      }
                      onClick={() => window.scrollTo(0, 0)}
                    >
                      {label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>

            {/* Language Selector - Right side with increased size */}
            <div className="flex items-center justify-end mr-0.2 md:ml-4 lg:ml-2">
              <button 
                onClick={toggleTranslator}
                className="flex items-center gap-1 text-white font-medium text-sm md:text-base border border-gray-600 px-[4px] py-0.4 rounded-md hover:bg-gray-800 transition-all md:border-none md:px-0 md:py-0 md:gap-2"
                aria-label="Change language"
              >
                <FaLanguage className="hidden md:inline text-xs md:text-xl" />
                <span className="md:whitespace-nowrap">
                  <span className="md:hidden text-xs">Language</span>
                  <span className="hidden md:inline">Change Language</span>
                </span>
              </button>
            </div>
          </div>

          {/* Tablet Navigation - Increased height and text size */}
          <div className="hidden md:flex lg:hidden justify-center w-full bg-[#000300] border-t border-gray-800 py-3">
            <ul className="flex items-center space-x-5 md:space-x-7 overflow-x-auto px-4 hide-scrollbar">
              {navItems.map(({ path, label }) => (
                <li key={path}>
                  <NavLink
                    to={path}
                    className={({ isActive }) =>
                      `text-sm md:text-[0.95rem] whitespace-nowrap transition-colors duration-300 ${
                        isActive 
                          ? "text-gray-400 font-semibold" 
                          : "text-white hover:text-gray-400"
                      }`
                    }
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    {label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        </nav>
      </header>

      {/* Mobile Menu */}
      {showMenu && (
        <div className="md:hidden fixed top-[calc(3.5rem+1rem)] left-0 w-full bg-white shadow-md transition-all duration-300 z-[1000]">
          <ResponsiveMenu setShowMenu={setShowMenu} showMenu={showMenu} />
        </div>
      )}

      {/* Translator Card Popup */}
      <Translator show={showTranslator} onClose={toggleTranslator} />

      <style jsx>{`
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </>
  );
};

export default Navbar;